import React from 'react';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { Container, View } from '@amzn/stencil-react-components/layout';
import { Col } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import { FormattedMessage } from 'react-intl';

const LoadingAppLayout = ({ height }) => {
  return (
    <Container
      data-testid="loadingComponent"
      padding={0}
      backgroundColor="primary70"
      isFullWidth={true}
    >
      <Col
        height={height}
        gridGap="S200"
        backgroundColor="neutral05"
        padding={0}
        justifyContent="center"
        alignItems="center"
      >
        <Spinner size={SpinnerSize.Medium} />
        <Text>
          <FormattedMessage
            id="app.appLoading.text"
            defaultMessage="Please wait for a moment. Loading the app."
          />
        </Text>
      </Col>
    </Container>
  );
};

export default LoadingAppLayout;
